import React from 'react';
import classes from './columns.css';
import Description from './Description/description';
import Contact from './Contact/contact';
import GST from './GST/gst';
import Classification from './Classification/classification';
import AccountCode from './AccountCode/accountCode';
import StatusIcons from './StatusIcons/statusIcons';
import Quantity from './Quantity/quantity';
import SelectBox from './SelectBox/selectBox';
import BatchTickbox from './SelectBox/batchTickbox';

export const initColumns = (hasGST, isR1, isRah, contacts, account, transactionCodes, editableDescription, displayAccount, classifications, transactionsList, selectTransactions, selectTransaction, deselectTransaction, isRuleFound, matchLoadingList, handleGST, handleContact, handleClassification, handleDescription, handleUndoDescription, handleQuantity, handleAcceptRule, handleRemoveRule, showRuleModal, showCommentsModal, sortGrid, sortColumn, sortOrder, activateCell, handleSelectAccount, hideColumns = {}, matches, rows, taxTracking = true) => {
    const showContacts = isR1 ? contacts.length > 1 : contacts.length > 0;
    const arrowDown = "fas fa-long-arrow-alt-down pull-right";
    const arrowUp = "fas fa-long-arrow-alt-up pull-right";
    const isCreditCard = account.isCreditCard && isRah;
    // data for Contacts
    const contactsOut = [...contacts.filter((item) => (item.isSupplier)), ...contacts.filter(item => item.isEmployee),
    ...contacts.filter(item => item.isSuperfund), ...contacts.filter(item => item.isOther)];
    const contactsIn = [...(isCreditCard ? [...contacts.filter(item => item.isSupplier), ...contacts.filter(item => item.isEmployee)] : []),
    ...contacts.filter(item => item.isCustomer), ...contacts.filter(item => item.isOther)];

    let columns = [
        {
        id: 'batchTickbox',
        tabStop: true,
        title: () => <BatchTickbox rows={rows} isRah={isRah} matches={matches} selectTransaction={selectTransaction} selectTransactions={selectTransactions} />,
        value: (row, { focus, active, disabled }) => <SelectBox focus={focus} active={active} disabled={disabled} selectTransaction={selectTransaction} deselectTransaction={deselectTransaction} row={row} transactionsList={transactionsList} />
        },  
        {
            id: 'transactionDate',
            title: () => <div className={classes.sortHeading} onClick={() => sortGrid('date')}><div>Date</div> {(sortColumn === 'date') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
            value: row => <span title={row.TransactionDate}>{row.TransactionDate}</span>
        },
        {
            id: 'description',
            title: () => <div className={classes.sortHeading} onClick={() => sortGrid('Description')}><div>Description</div> {(sortColumn === 'Description') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
            tabStop: 'enable',
            columnData: { editableDescription },
            value: (row, { focus, active, disabled }) => <Description active={active} focus={focus} disabled={disabled} elementFocused={activateCell} row={row} editableDescription={editableDescription} isRuleFound={isRuleFound} handleDescription={handleDescription} handleUndoDescription={handleUndoDescription} />,
            getCellClassName: (row) => (editableDescription !== true || isRuleFound(row) ? classes.select_cell : classes.editableDescriptionClass)
        },
        {
            id: 'moneyOut',
            title: () => <div className={classes.sortHeading} onClick={() => sortGrid('Money out')}><div>Money out</div> {(sortColumn === 'Money out') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
            value: (row) => (row.Amount && row.Amount < 0) ? <span>{(row.Amount * -1).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</span> : '',
            // getCellClassName: () => ''
        },
        {
            id: 'moneyIn',
            title: () => <div className={classes.sortHeading} onClick={() => sortGrid('Money in')}><div>Money in</div> {(sortColumn === 'Money in') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
            value: (row) => (row.Amount && row.Amount >= 0) ? <span>{row.Amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</span> : '',
            // getCellClassName: () => ''
        },
        {
            id: 'accountCode',
            title: () => <div className={classes.sortHeading} onClick={() => sortGrid('AccountCode')}><div>Account</div> {(sortColumn === 'AccountCode') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
            getCellClassName: () => (classes.select_cell),
            columnData: { displayAccount },
            tabStop: true,
            value: (row, { focus, active, disabled, coords, width }) => <AccountCode width={width} focus={focus} active={active} disabled={disabled} coords={coords} elementFocused={activateCell} row={row} matches={matches} transactionCodes={transactionCodes} handleAcceptRule={handleAcceptRule} handleRemoveRule={handleRemoveRule} isRuleFound={isRuleFound} displayAccount={displayAccount} handleSelectAccount={handleSelectAccount} isRah={isRah} isR1={isR1} isCreditCardMoneyIn={isCreditCard && row.Amount && row.Amount >= 0} />
        }
    ];

    const contact = {
        id: 'contactId',
        title: () => <div className={classes.sortHeading} onClick={() => sortGrid('contactId')}><div>Contact</div> {(sortColumn === 'contactId') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
        getCellClassName: () => (classes.select_cell),
        tabStop: 'enable',
        value: (row, { disabled, focus, active, width, coords }) => {
            return <Contact width={width} isR1={isR1} active={active} coords={coords} elementFocused={activateCell} row={row} contacts={contacts} contactsOut={contactsOut} contactsIn={contactsIn} isRuleFound={isRuleFound} disabled={disabled} focus={focus} handleContact={handleContact} />
        }
    };

    const classification = {
        id: 'classificationId',
        title: () => <div className={classes.sortHeading} onClick={() => sortGrid('classificationId')}><div>Classification</div> {(sortColumn === 'classificationId') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
        getCellClassName: () => (classes.select_cell),
        tabStop: 'enable',
        value: (row, { focus, disabled, active, width, coords }) => <Classification width={width} coords={coords} isR1={isR1} active={active} elementFocused={activateCell} row={row} classifications={classifications} isRuleFound={isRuleFound} handleClassification={handleClassification} disabled={disabled} focus={focus} />
    };

    const gstAmount = {
        id: 'gstAmount',
        title: () => <div className={classes.sortHeading} onClick={() => sortGrid('gstAmount')}><div>Tax</div> {(sortColumn === 'gstAmount') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
        value: (row) => ((row.gstAmount || row.GstCode) && !isRuleFound(row)) ? <span>{Math.abs(row.gstAmount).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</span> : '',
        // getCellClassName: () => ('')
    };

    const gstCode = {
        id: 'gstCode',
        title: () => <div className={classes.sortHeading} onClick={() => sortGrid('GstCode')}><div>Tax code</div> {(sortColumn === 'GstCode') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
        getCellClassName: () => (classes.select_cell),
        tabStop: 'enable',
        value: (row, { disabled, focus, active, width, coords }) => <GST width={width} coords={coords} isR1={isR1} elementFocused={activateCell} row={row} isCreditCard={isCreditCard} transactionCodes={transactionCodes} isRuleFound={isRuleFound} disabled={disabled} focus={focus} active={active} handleGST={handleGST} />
    };

    const statusIcons = {
        id: 'statusIcons',
        title: () => 'Status',
        value: row => <StatusIcons row={row} isR1={isR1} isRah={isRah} showRuleModal={showRuleModal} showCommentsModal={showCommentsModal} matchLoadingList={matchLoadingList} />
    };

    const reference = {
        id: 'traceId',
        title: () => <div className={classes.sortHeading} onClick={() => sortGrid('TraceID')}><div>Ref   </div> {(sortColumn === 'TraceID') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
        value: (row) => <span title={row.TraceID}>{row.TraceID}</span>,
        // getCellClassName: () => ('')
    }

    const type = {
        id: 'type',
        title: () => <div className={classes.sortHeading} onClick={() => sortGrid('TransactionType')}><div>Type</div> {(sortColumn === 'TransactionType') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
        value: (row) => <span title={row.TransactionType}>{row.TransactionType}</span>,
        // getCellClassName: () => ('')
    }

    const quantity = {
        id: 'quantity',
        tabStop: true,
        title: () => <div className={classes.sortHeading} onClick={() => sortGrid('Quantity')}><div>Qty</div> {(sortColumn === 'Quantity') ? <i className={(sortOrder) ? arrowUp : arrowDown}></i> : null}</div>,
        getCellClassName: () => (classes.select_cell),
        value: (row, { focus, active, disabled }) => <Quantity focus={focus} active={active} disabled={disabled} elementFocused={activateCell} row={row} handleQuantity={handleQuantity} />
    }

    const enableRules = localStorage.getItem("enablerules");
    let hidden = 0;

    if (!hideColumns.reference) {
        columns.splice(2 - hidden, 0, reference);
    } else {
        hidden++;
    }

    if (!hideColumns.type) {
        columns.splice(3 - hidden, 0, type);
    } else {
        hidden++;
    }

    if (!hideColumns.quantity) {
        columns.splice(7 - hidden, 0, quantity);
    } else {
        hidden++;
    }

    if (showContacts && !hideColumns.contact) columns.push(contact);
    if (Boolean(classifications.length) && !hideColumns.classification) columns.push(classification);
    if (hasGST && taxTracking) {
        columns.splice(9 - hidden, 0, gstCode);
        columns.splice(10 - hidden, 0, gstAmount);
    }

    columns.push(statusIcons);

    return columns;
}


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/columns.js